import React from 'react';
import { CSSProgressLoader } from '@jobmatchme/ui';
import styles from './style.module.scss';

var PageLoadingSpinner = function PageLoadingSpinner(_ref) {
  var fullHeight = _ref.fullHeight,
      loadingMessage = _ref.loadingMessage;
  return React.createElement("div", {
    className: styles.spinnerWrapper,
    style: {
      height: fullHeight ? '100vh' : 'auto',
      display: 'flex',
      textAlign: 'center',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column'
    }
  }, loadingMessage && React.createElement("div", {
    className: styles.loadingMessage
  }, loadingMessage), React.createElement(CSSProgressLoader, null));
};

export default PageLoadingSpinner;